<template>
  <section v-if="overview" class="bg-white rounded-xl border border-gray-100 shadow-sm p-5 md:p-6">
    <div class="tw-flex items-center justify-between mb-4">
      <h3 class="text-base font-semibold text-gray-900 m-0">Key metrics</h3>
    </div>

    <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <!-- Registered users (with / without invitees) -->
      <div class="rounded-lg border border-gray-100 bg-gray-50 p-4">
        <p class="text-xs font-semibold uppercase tracking-wide text-gray-500 m-0 mb-1">Registered users</p>
        <p class="text-2xl font-semibold text-gray-900 m-0">{{ overview.registered_users }}</p>
        <p class="text-xs text-gray-400 m-0 mt-1">
          {{ overview.registered_users_with_invitees }} incl. invitees<span v-if="overview.open_invitations"> (+{{ overview.open_invitations }})</span>
        </p>
      </div>

      <!-- Active users -->
      <div class="rounded-lg border border-gray-100 bg-gray-50 p-4">
        <p class="text-xs font-semibold uppercase tracking-wide text-gray-500 m-0 mb-1">Active users</p>
        <p class="text-2xl font-semibold text-gray-900 m-0">{{ overview.active_users }}</p>
        <p class="text-xs text-gray-400 m-0 mt-1">active in {{ monthLabel }}</p>
      </div>

      <!-- Actors claimed / unclaimed -->
      <div class="rounded-lg border border-gray-100 bg-gray-50 p-4">
        <p class="text-xs font-semibold uppercase tracking-wide text-gray-500 m-0 mb-1">Actors</p>
        <div class="tw-flex items-baseline gap-2">
          <span class="text-2xl font-semibold text-gray-900">{{ overview.actors_claimed }}</span>
          <span class="text-xs text-gray-400">claimed / {{ overview.actors_unclaimed }} unclaimed</span>
        </div>
        <div class="mt-2 h-1.5 w-full rounded-full bg-gray-200 overflow-hidden">
          <div class="h-full rounded-full bg-primary" :style="{ width: actorsClaimedPct + '%' }"></div>
        </div>
        <p class="text-xs text-gray-400 m-0 mt-1">{{ actorsClaimedPct }}% of {{ overview.actors_total }} claimed</p>
      </div>

      <!-- Products claimed / unclaimed -->
      <div class="rounded-lg border border-gray-100 bg-gray-50 p-4">
        <p class="text-xs font-semibold uppercase tracking-wide text-gray-500 m-0 mb-1">{{ productsLabel }}</p>
        <div class="tw-flex items-baseline gap-2">
          <span class="text-2xl font-semibold text-gray-900">{{ overview.products_claimed }}</span>
          <span class="text-xs text-gray-400">claimed / {{ overview.products_unclaimed }} unclaimed</span>
        </div>
        <div class="mt-2 h-1.5 w-full rounded-full bg-gray-200 overflow-hidden">
          <div class="h-full rounded-full bg-primary" :style="{ width: productsClaimedPct + '%' }"></div>
        </div>
        <p class="text-xs text-gray-400 m-0 mt-1">{{ productsClaimedPct }}% of {{ overview.products_total }} claimed</p>
      </div>
    </div>
  </section>
</template>

<script>
  import moment from 'moment'
  import TranslationsMixin from '../../../util/TranslationsMixin.js'

  export default {
    name: 'HeartbeatKeyMetrics',
    mixins: [TranslationsMixin],
    props: {
      overview: Object,
      date: String,
    },
    computed: {
      monthLabel () {
        return this.date ? moment(this.date).format('MMMM YYYY') : 'this period'
      },
      actorsClaimedPct () {
        return this.claimedPct(this.overview && this.overview.actors_claimed, this.overview && this.overview.actors_total)
      },
      productsClaimedPct () {
        return this.claimedPct(this.overview && this.overview.products_claimed, this.overview && this.overview.products_total)
      },
    },
    methods: {
      claimedPct (claimed, total) {
        if (!total || total <= 0) {
          return 0
        }

        return Math.round((claimed / total) * 100)
      },
    },
  }
</script>
